export default {
  approvedSeller: {
    id: 'seller_page_main_seller_info_approved_seller',
    defaultMessage: 'Approved seller with {rating, html}',
  },
  sellerRating: {
    id: 'seller_page_main_seller_info_seller_rating',
    defaultMessage: '{rating, number}/{maxRating, number} Stars rating',
  },
  trustedPeriod: {
    id: 'seller_page_main_seller_info_trusted_period',
    defaultMessage: 'Trusted on Back Market for {period, html}',
  },
  years: {
    id: 'seller_page_main_seller_info_years',
    defaultMessage: `{years, plural,
      one {# year}
      other {# years}
    }`,
  },
  months: {
    id: 'seller_page_main_seller_info_months',
    defaultMessage: `{months, plural,
      one {# month}
      other {# months}
    }`,
  },
  basedIn: {
    id: 'seller_page_main_seller_info_based_in',
    defaultMessage: 'Based in {country}',
  },
} as const
